<div class="ic1-row" *ngIf="this.router.url !== '/multi-cert'">
  <img
    class="tablet"
    (click)="goToHomepage()"
    src="assets/images/arrow-back.svg" />
  <ng-ui-kit-breadcrumb [items]="breadcrumbItems$ | async">
  </ng-ui-kit-breadcrumb>
</div>
<!-- Lasciare per adesso commentato -->
<!-- <ol class="breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs">
    <span [routerLink]="breadcrumb.url" routerLinkActive="router-link-active">
      {{ breadcrumb.label }}
    </span>
  </li>
</ol> -->
